import { render, staticRenderFns } from "./Requerimientos.vue?vue&type=template&id=64c5c6c0"
import script from "./Requerimientos.vue?vue&type=script&lang=js"
export * from "./Requerimientos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports